@if (query.page()) {
  <app-ref-list #list [page]="query.page()"
                [newRefs$]="newRefs$"
                [insertNewAtTop]="true"
                [expanded]="true"
                i18n-emptyMessage emptyMessage="No logs found" />
}
